import styled from 'styled-components';
import {Button, IconButton, Typography} from "@mui/material";

export const SidebarDataSourcesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const SidebarDataSourcesHeader = styled(Typography)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const AllDataSourcesButton = styled(IconButton)`
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background-color: transparent;
    }

    svg {
        width: 22px;
        height: 22px;
        flex-shrink: 0;
    }
`;

export const SidebarDataSourcesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
`;

export const SidebarDataSourceItem = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    text-align: left;
    gap: 8px;

    font-size: ${({ theme }) => theme.typography.body2};
    cursor: pointer;
    transition: background-color 0.2s;

    & .MuiButton-startIcon {
        display: flex;
        align-items: center;
        margin: 0 4px 4px 0;
        flex-shrink: 0;
    }
    
    &:hover {
        background-color: ${({ theme }) => theme.palette.action.hover};
    }

    svg {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        color: ${({ theme }) => theme.palette.primary.main};
        margin-left: 2px;
    }
    
    span {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-shrink: 1;
    }
`;
